import React, { useEffect, useState } from "react";
import { Flex, Text, Box } from "@chakra-ui/react";
import { useTutor } from "../../../../context/AiTutorContext";
import { useRoot } from "../../../../context/RootContext";
import useStateRef from "react-usestateref";
import {
  fetchMasterIdMappingTopics,
  fetchSubtopicListById,
  getTopicFeaturesData,
} from "../../../../network/TutorApiService";
import { styles } from "./TutorSubjectStyles";
import SubTopicsListing from "./SubTopicsListing";
import OtherActions from "./OtherActions";
import RowItem from "./RowItem";
import { isEmptyOrNull } from "../../../../utils/common-utils";

export default function TutorSubjects({ isDoubtScreen, handleSelect }) {
  //prettier-ignore
  const { grade, subject, topic, setGrade, setSubject, setTopic,
    setSubjectMasterUUid, setTopicMasterUuid, setGradeId } = useTutor();
  const { setSubjectName, setTopicName, setTaskType, setIsSubjectLevelDoubt, setTtsPlaygroundObj } = useRoot();
  const [gradesList, setGradesList] = useState([]);
  const [subjectsList, setSubjectsList] = useState([]);
  const [topicsList, setTopicsList] = useState([]);
  const [list, setList, listRef] = useStateRef([]);
  const [selectedTopic, setSelectedTopic] = useState({});
  const [subTopicList, setSubtopicList] = useState([]);
  const [selectedSubTopic, setSelectedSubTopic] = useState({});
  const [subjectLevelTopicFeatures, setSubjectLevelTopicFeatures] = useState([]);
  const [topicsIdList, setTopicsIdList] = useState([]);


  useEffect(() => {
    handleClear("", 0);
    getMatserIdsMappingList();
  }, []);

  useEffect(() => {
    if (listRef?.current?.length > 0) {
      fetchGrades();
    }
  }, [list]);

  const getMatserIdsMappingList = async () => {
    const response = await fetchMasterIdMappingTopics();
    setList(response || []);
  };

  const getTopicFeatures = async (subjectId) => {
    const response = await getTopicFeaturesData(subjectId);
    if (response?.success) {
      setSubjectLevelTopicFeatures(response?.data?.topics);
    } else {
      console.error("error", response?.message);
    }
  }
  const handleClear = (level, item) => {
    if (level == 0) {
      const gradeId = fetchIdByName(item, "grade_id", 0);
      setGrade(item);
      setGradeId(gradeId);
      setTtsPlaygroundObj((prev) => ({ ...prev, grade: item, grade_id: gradeId }));
      clearSubject();
      clearTopic();
      clearSubTopic();
      fetchSubjectsList(item);
    } else if (level == 1) {
      const subjectID = fetchIdByName(item, "subject_id", 1);
      setSubject(item);
      setSubjectName(item);
      setSubjectMasterUUid(subjectID);
      setTtsPlaygroundObj((prev) => ({ ...prev, subject: item, subject_id: subjectID }));
      clearTopic();
      fetchTopicsList(item);
      getTopicFeatures(subjectID);
    } else if (level == 2) {
      let topicID = fetchIdByName(item, "chapter_id", 2);
      setTtsPlaygroundObj((prev) => ({ ...prev, topic_name: item, topic_name_id: topicID }));
      if (isDoubtScreen) {
        setTopic(item);
        setTopicName(item);
        setTopicMasterUuid(topicID);
      } else {
        setSelectedTopic({ label: item, value: topicID });
        clearSubTopic();
        fetchSubtopicsList(topicID);
      }
    } else if (level == 3) {
      setSelectedSubTopic(item);
    }
  };
  const clearSubject = () => {
    setSubjectsList([]);
    setSubject("");
    setSubjectName("");
    setSubjectMasterUUid("");
  };
  const clearTopic = () => {
    setTopicsList([]);
    setTopicsIdList([]);
    setSelectedTopic({});
    setTopic("");
    setTopicName("");
    setTopicMasterUuid("");
  };
  const clearSubTopic = () => {
    setSubtopicList([]);
    setSelectedSubTopic({});
  };
  const fetchIdByName = (name, key, level) => {
    let res = listRef?.current?.find((item) => {
      if (level == 0) {
        return item.grade == name;
      } else if (level == 1) {
        return item.grade == grade && item.subject == name;
      } else if (level == 2) {
        return (
          item.grade == grade && item.subject == subject && item.chapter == name
        );
      }
    });
    res = res?.[key] || "";
    return res;
  };
  const fetchGrades = () => {
    let grades = listRef?.current?.map((item) => parseInt(item.grade));
    grades = [...new Set(grades)]
      .sort((a, b) => a - b)
      .map((item) => item.toString());
    setGradesList(grades);
  };
  const fetchSubjectsList = (gradeValue) => {
    const subjects = listRef?.current
      ?.filter((item) => item.grade.toString() === gradeValue)
      .map((item) => item.subject);
    setSubjectsList([...new Set(subjects)]);
  };
  const fetchTopicsList = (subjectValue) => {
    const filteredItems = listRef?.current?.filter(
      (item) =>
        item.grade.toString() === grade &&
        item.subject.toString() === subjectValue
    );

    const topics = filteredItems.map((item) => item.chapter);
    const topicIds = filteredItems.map((item) => item.chapter_id);

    setTopicsList([...new Set(topics)]);
    setTopicsIdList([...new Set(topicIds)]);
  };

  const fetchSubtopicsList = async (topicID) => {
    let { data = [] } = await fetchSubtopicListById(topicID);
    let intialData = Object.values(data?.[0])?.[0] || [];
    intialData = intialData?.map((item) => {
      return {
        value: item?.subTopic?.[0],
        label: item?.name,
        uuid: item?._id,
      };
    });
    setSubtopicList(intialData);
  };

  const gradeTitle = `Hi! Ready to start learning? Choose your grade and let's dive in!`;
  return (
    <Flex {...styles.mainWrapper}>
      <GradesSubjectsListing
        title={gradeTitle}
        data={gradesList}
        selectedValue={grade}
        onClick={(item) => handleClear(0, item)}
      />
      {subjectsList?.length > 0 && (
        <GradesSubjectsListing
          title={"Which subject would you like to work on?"}
          data={subjectsList}
          selectedValue={subject}
          onClick={(item) => handleClear(1, item)}
        />
      )}
      {!isEmptyOrNull(subject) && isDoubtScreen &&
        <RowItem
          item={'Got a doubt?'}
          isSelected={true}
          onClick={() => {
            setIsSubjectLevelDoubt(true)
          }}
          containerStyles={{ w: "50%", h: "36px", bg: "#1D287AD9" }}
          textStyles={{ fontSize: "16px", fontWeight: "600" }}

        />
      }
      {topicsList?.length > 0 && (
        <TopicsSubTopicsListing
          title={"Now choose your topic:"}
          topics={topicsList}
          topicsId={topicsIdList}
          subTopics={subTopicList}
          topic={selectedTopic?.label || topic}
          subTopic={selectedSubTopic?.label}
          handleAction={(action) => {
            setTaskType(action);
            handleSelect(action, selectedTopic, selectedSubTopic);
          }}
          onClick={(item, type) => {
            handleClear(type == "topic" ? 2 : 3, item);
          }}
          subjectLevelTopicFeatures={subjectLevelTopicFeatures}
        />
      )}
    </Flex>
  );
}

const GradesSubjectsListing = ({ title, data, selectedValue, onClick }) => {
  return (
    <Flex {...styles.listingContainer}>
      <Text {...styles.listingTitle}>{title}</Text>
      <Flex {...styles.flexRow}>
        {data?.map((item, index) => (
          <RowItem
            key={`grade-${index}`}
            item={item}
            isSelected={selectedValue === item}
            onClick={onClick}
            width={120}
          />
        ))}
      </Flex>
    </Flex>
  );
};

const TopicsSubTopicsListing = (props) => {
  const { topics, subTopics, topic, subTopic, onClick, topicsId, subjectLevelTopicFeatures } = props;
  return (
    <Flex {...styles.listingContainer}>
      <Text {...styles.listingTitle}>{props?.title}</Text>
      <Flex {...styles.flexRow}>
        {topics?.map((item, index) => {
          // Find topicId corresponding to this topic
          const topicId = topicsId[index];
          const matchedFeature = subjectLevelTopicFeatures.find((feat) => feat?.master_uuid === topicId);
          const isEnabled = matchedFeature?.is_enabled || undefined;
          const topicFeatures = matchedFeature?.topic_features || [];

          return (
            <React.Fragment key={`topic-${index}`}>
              <RowItem
                item={item}
                isSelected={topic === item}
                isEnabled={isEnabled} // pass this
                onClick={() => {
                  onClick(item, "topic");
                }}
                width={"80%"}
              />
              {topic === item && (
                <Box w={"80%"} pl={2}>
                  <OtherActions isTopic={true} onClick={props?.handleAction} topicFeatures={topicFeatures} />
                  <SubTopicsListing
                    subTopics={subTopics}
                    subTopic={subTopic}
                    onClick={onClick}
                    handleAction={props?.handleAction}
                    topicFeatures={topicFeatures}
                  />
                </Box>
              )}
            </React.Fragment>
          );
        })}

      </Flex>
    </Flex>
  );
};